"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DAYS = exports.MONTHS = exports.PLANNER_YEARS = exports.PLANNER_MONTHS = exports.PLANNER_WEEK = exports.PLANNER_TOP = exports.PLANNER_HEADER = exports.PLANNER_DAY = exports.MODAL_TWO = exports.MODAL_CALENDAR_NAMESPACE = exports.MODAL_CALENDAR_NAME = exports.PLANNER_NAMESPACE = exports.PLANNER_NAME = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
exports.PLANNER_NAME = "planner";
exports.PLANNER_NAMESPACE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-").concat(exports.PLANNER_NAME);
exports.MODAL_CALENDAR_NAME = 'modal-planner';
exports.MODAL_CALENDAR_NAMESPACE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-").concat(exports.MODAL_CALENDAR_NAME);
exports.MODAL_TWO = 2;
exports.PLANNER_DAY = "".concat(exports.PLANNER_NAMESPACE, "-day");
exports.PLANNER_HEADER = "".concat(exports.PLANNER_NAMESPACE, "-header");
exports.PLANNER_TOP = "".concat(exports.PLANNER_NAMESPACE, "-top");
exports.PLANNER_WEEK = "".concat(exports.PLANNER_NAMESPACE, "-week");
exports.PLANNER_MONTHS = "".concat(exports.PLANNER_NAMESPACE, "-months");
exports.PLANNER_YEARS = "".concat(exports.PLANNER_NAMESPACE, "-years");
exports.MONTHS = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
exports.DAYS = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
